import { useContext, useState } from "react";
import { AppContext } from "../App";
import logo from '../assets/logo.png';
import { 
  MdClose, 
  MdHome, 
  MdInfo, 
  MdHandshake,
  MdQuestionAnswer, 
  MdContactPage, 
  MdCollections, 
  MdNewspaper,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp
} from "react-icons/md";
import Backdrop from "./Backdrop";

export default function SideBar(props) {
  const appContext = useContext(AppContext);
  
  // State kwa ajili ya kufungua dropdowns kwenda chini
  const [aboutOpen, setAboutOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);

  function closeSideBar() {
    if (appContext.setIsSideBarOpen) {
      appContext.setIsSideBarOpen(false);
    } else if (appContext.closeSideBar) {
      appContext.closeSideBar();
    }
  }

  function goTo(item, subItem) {
    appContext.navTo({
      item, subItem
    });

    if (appContext.isSideBarOpen) {
      closeSideBar();
    }
  }

  return (
    <>
    <Backdrop
        style={{
          visibility: appContext.isSideBarOpen ? "visible" : "hidden",
          opacity: appContext.isSideBarOpen ? "1" : "0",
          zIndex: "9999",
          pointerEvents: appContext.isSideBarOpen ? "auto" : "none",
        }}
      />
    <div
      className="SideBar mShadow4"
      data-open={appContext.isSideBarOpen}
    >
      <div className="body mNoScrollBar d-flex flex-column justify-content-between h-100 py-4 px-3">
        
        <div>
          {/* CLOSE BUTTON */}
          <div className="d-flex justify-content-end mb-2">
            <button 
              className="btn border-0 p-1 text-secondary sidebar-close-btn rounded-circle d-flex align-items-center justify-content-center"
              onClick={closeSideBar}
            >
              <MdClose size={26} />
            </button>
          </div>

          {/* LOGO */}
          <div className="logo-holder text-center mb-4 px-2">
            <img
              src={logo}
              alt="YCSC Logo"
              className="img-fluid sidebar-premium-logo"
            />
          </div>

          <hr className="text-secondary-subtle opacity-25 mb-4" />

          {/* NAVIGATION MENU */}
          <div className="sidebar-menu-wrapper d-flex flex-column gap-1">
            
            {/* 1. Home */}
            <div
              className="pill font-semi-bold"
              onClick={() => goTo("home")}
              data-active={(!appContext.navItem || appContext.navItem === 'home')}
            >
              <span className="pill-icon-wrapper"><MdHome size={22} /></span>
              <p className="text m-0">NYUMBANI</p>
            </div>

            {/* 2. About Us (Dropdown inashuka chini) */}
            <div className="sidebar-dropdown-block">
              <div
                className="pill font-semi-bold"
                onClick={() => setAboutOpen(!aboutOpen)}
                data-active={appContext.navItem?.startsWith('about_')}
              >
                <span className="pill-icon-wrapper"><MdInfo size={22} /></span>
                <p className="text m-0">KUHUSU SISI</p>
                <span className="ms-auto arrow-indicator">
                  {aboutOpen ? <MdKeyboardArrowUp size={22} /> : <MdKeyboardArrowDown size={22} />}
                </span>
              </div>
              
              <div className={`sidebar-vertical-menu ${aboutOpen ? "open" : ""}`}>
                <div 
                  className="sub-pill font-regular" 
                  onClick={() => goTo("about_us")}
                  data-active={appContext.navItem === 'about_us'}
                >
                  MUHTASARI & MAADILI
                </div>
                <div 
                  className="sub-pill font-regular" 
                  onClick={() => goTo("leadership")}
                  data-active={appContext.navItem === 'leadership'}
                >
                  UONGOZI & UTAWALA
                </div>
              </div>
            </div>

            {/* 3. Services (Dropdown inashuka chini) */}
            <div className="sidebar-dropdown-block">
              <div
                className="pill font-semi-bold"
               
                data-active={appContext.navItem?.startsWith('services_')}
              >
                <span className="pill-icon-wrapper"><MdHandshake size={22} /></span>
                <p  onClick={() => goTo("services")} className="text m-0">HUDUMA ZETU</p>
                <span  onClick={() => setServicesOpen(!servicesOpen)} className="ms-auto arrow-indicator">
                  {servicesOpen ? <MdKeyboardArrowUp size={22} /> : <MdKeyboardArrowDown size={22} />}
                </span>
              </div>
              
              <div className={`sidebar-vertical-menu ${servicesOpen ? "open" : ""}`}>
              <div 
                  className="sub-pill font-regular" 
                  onClick={() => goTo("services", "loans")}
                  data-active={appContext.navItem === 'services' && appContext.navSubItem === 'loans'}
                >
                  MIKOPO YETU
                </div>
                <div 
                  className="sub-pill font-regular" 
                  onClick={() => goTo("services", "savings_deposits")}
                  data-active={appContext.navItem === 'services' && appContext.navSubItem === 'savings_deposits'}
                >
                  HISA, AKIBA & AMANA
                </div>
              </div>
            </div>

            {/* 4. News */}
            <div
              className="pill font-semi-bold"
              onClick={() => goTo("news")}
              data-active={(appContext.navItem === 'news')}
            >
              <span className="pill-icon-wrapper"><MdNewspaper size={22} /></span>
              <p className="text m-0">HABARI</p>
            </div>

            {/* 5. Gallery */}
            <div
              className="pill font-semi-bold"
              onClick={() => goTo("gallery")}
              data-active={(appContext.navItem === 'gallery')}
            >
              <span className="pill-icon-wrapper"><MdCollections size={22} /></span>
              <p className="text m-0">MATUNZIO</p>
            </div>

            {/* 6. FAQs */}
            <div
              className="pill font-semi-bold"
              onClick={() => goTo("faqs")}
              data-active={(appContext.navItem === 'faqs')}
            >
              <span className="pill-icon-wrapper"><MdQuestionAnswer size={22} /></span>
              <p className="text m-0">FAQS</p>
            </div>

            {/* 7. Contact Us */}
            <div
              className="pill font-semi-bold"
              onClick={() => goTo("contact_us")}
              data-active={(appContext.navItem === 'contact_us')}
            >
              <span className="pill-icon-wrapper"><MdContactPage size={22} /></span>
              <p className="text m-0">WASILIANA NASI</p>
            </div>

          </div>
        </div>

        {/* FOOTER */}
        <div className="sidebar-footer-brand text-center pt-3">
          <div className="bg-warning-subtle text-warning-dark py-2 px-3 rounded-3 small font-semi-bold shadow-sm">
            "Mshikamano Daima"
          </div>
          <span className="d-block tiny-label text-muted font-light mt-2" style={{ fontSize: '0.65rem' }}>
            &copy; 2026 YCSC SACCOS Ltd.
          </span>
        </div>

      </div>
    </div>
    </>
  );
}